module.exports = __webpack_public_path__ + "img/Speaker=Linda Chen.f8289633.png";